import { connect } from 'react-redux'
import {
    isBottomBarSocialSharingAsideDisplayed,
    isImageSettingAsideDisplayed,
    isZoomAsideDisplayed,
} from 'redux/aside/selectors'
import BottomBar from './BottomBar.jsx'
import {
    getBrightness,
    getContrast,
    getUserScale,
    isInvertActive,
} from 'redux/appliedFilters/selectors'
import {
    contrast,
    brightness,
    invert,
    zoom,
} from 'redux/appliedFilters/actions'
import { isResponsiveModeEnabled } from '../../../redux/visualizer/selectors'

const mapDispatchToProps = dispatch => ({
    onInvertChange : () => dispatch(invert())
})

const mapStateToProps = state => ({
    brightnessValue: getBrightness(state),
    brightnessAction: brightness,
    contrastValue: getContrast(state),
    contrastAction: contrast,
    isInvertActive: isInvertActive(state),
    scale: getUserScale(state),
    zoomAction: zoom,
    isImageSettingAsideDisplayed: isImageSettingAsideDisplayed(state),
    isZoomAsideDisplayed: isZoomAsideDisplayed(state),
    isResponsiveModeEnabled: isResponsiveModeEnabled(state),
    isSocialSharingAsideDisplayed: isBottomBarSocialSharingAsideDisplayed(state),
})

export const BottomBarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(BottomBar)
